import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './RateCalculator.css';
import Select from 'react-select';
import ReactCountryFlag from 'react-country-flag';

function RateCalculator() {

  const [formData, setFormData] = useState({
    origin: 'India',
    destination: '',
    weight: '',
    cargoType: '',
  });

  const [countries, setCountries] = useState([]);
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');


  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: 'ease-in-out',
      once: false,
      mirror: true,
    });

    fetch("http://localhost:8080/api/countries/view")
      .then(res => res.json())
      .then(data => {
        if (data?.data) {
          const active = data.data
            .filter(c => c.active)
            .map(c => ({
              value: c.name,
              label: c.name,
              code: c.code
            }));
          setCountries(active);
        }
      })
      .catch(() => setError("Failed to load countries"));

  }, []);

  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ============================
  // HANDLE SELECT (react-select)
  // ============================
  const handleCountryChange = (selected) => {
    setFormData({ ...formData, destination: selected?.value || '' });
  };

   const roundUp = (
      value) => Math.ceil(Number(value));

  // ============================
  // SUBMIT
  // ============================
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError('');
    setRates([]);

    try {
      const url = `http://localhost:8080/api/rate-calculator/rate?fromCountry=${formData.origin}&toCountry=${formData.destination}&weight=${formData.weight}&documentType=${formData.cargoType}`;

      const response = await fetch(url);
      const result = await response.json();

      if (result?.data?.length > 0) {
        setRates(result.data);
        setTimeout(() => AOS.refresh(), 100);
      } else {
        setError('No rates available for the selected route.');
      }

    } catch (err) {
      setError('Failed to fetch rates.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rate-calc-section d-flex flex-column align-items-center">

      {/* HEADER */}
      <div data-aos="fade-up" className="text-center mb-4">
        <h2 className="fw-bold text-success display-6">Rate Calculator</h2>
        <p className="text-muted">Get instant estimates from vendors</p>
      </div>

      {/* FORM */}
      <form
        className="rate-form shadow-lg p-4 bg-white rounded-4"
        onSubmit={handleSubmit}
        data-aos="zoom-in"
      >

        <div className="row">

          {/* ORIGIN (FIXED) */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Origin</label>
            <input
              type="text"
              value="India"
              className="form-control"
              disabled
            />
          </div>

          {/* DESTINATION (SEARCHABLE + FLAGS) */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Destination</label>

            <Select
              options={countries}
              onChange={handleCountryChange}
              placeholder="Search country..."
              isSearchable
              formatOptionLabel={(country) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <ReactCountryFlag
                    countryCode={country.code}
                    svg
                    style={{ width: '20px', height: '15px' }}
                  />
                  <span>{country.label}</span>
                </div>
              )}
            />

          </div>

        </div>

        <div className="row">


<div className="col-md-6 mb-3">
  <label className="form-label">Weight (kg)</label>

  <input
    type="number"
    step="0.5"
    min="0.5"
    name="weight"
    value={formData.weight}
    onChange={(e) => {
      const value = e.target.value;

      // allow empty
      if (value === "") {
        setFormData({ ...formData, weight: "" });
        setError("");
        return;
      }

      const num = parseFloat(value);

      if (num % 0.5 === 0) {
        setFormData({ ...formData, weight: value });
        setError("");
      } else {
        setError(
          "Kindly use weight values like: 1, 1.5, 2, 2.5, 3..."
        );
      }
    }}
    className="form-control"
    required
  />
</div>

          {/* TYPE */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Shipment Type</label>
            <select
              name="cargoType"
              value={formData.cargoType}
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="">Select</option>
              <option value="Document">Document</option>
              <option value="Non-Document">Non-Document</option>
            </select>
          </div>

        </div>

        <button className="btn btn-success w-100 rounded-pill mt-3">
          {loading ? 'Calculating...' : 'Calculate Rate'}
        </button>

      </form>

      {/* ERROR */}
      {error && (
        <div className="alert alert-warning mt-4">
          {error}
        </div>
      )}

      {/* TABLE */}
      {rates.length > 0 && (
        <div className="rate-table-wrapper mt-5 w-100">

          <h5 className="text-center fw-semibold mb-3">
            Available Vendor Rates
          </h5>

          <div className="table-responsive">
            <table className="table table-hover align-middle shadow-sm">

              <thead className="table-success">
                <tr>
                  <th>Vendor</th>
                  <th>Service</th>
                  <th>Rate / Kg</th>
                  <th>Weight</th>
                  <th>Total (₹)</th>
                </tr>
              </thead>

              <tbody>
                {rates.map((rate) => (
                  <tr key={rate.id}>
                    <td>{rate.vendor}</td>
                    <td>{rate.service}</td>
                    <td>₹ {(rate.ratePerKg)}</td>
                    <td>{rate.weight} kg</td>
                    <td className="text-success fw-bold">
                      ₹ {Math.ceil(rate.estimatedTotalCharge)}
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>
      )}

    </div>
  );
}

export default RateCalculator;